export const IconPinMapsNavigation: {
  name: 'icon_pin_maps_navigation-fdaea959c11b'
} = {
  name: 'icon_pin_maps_navigation-fdaea959c11b'
}
